"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractGameRule = void 0;
class AbstractGameRule {
    setNext(rule) {
        this.nextRule = rule;
        return rule;
    }
    execute(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.applyRule(commandHash, existingDeal, instant, context);
            if (!result && this.nextRule) {
                return yield this.nextRule.execute(commandHash, existingDeal, instant, context); // Pass to the next rule
            }
            return result; // Stop if handled
        });
    }
}
exports.AbstractGameRule = AbstractGameRule;
